import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
    PreviousSearchesListItem,
    SearchesSuggestionsListItem,
    ShopsSuggestionsListItem,
    AdvancedSearchListItem,
    SellerSearchListItem
} from './suggestion-list-items';

class SearchSuggestion extends React.Component {
    constructor(props) {
        super(props);
        // this.getSuggestions = throttle(this.getSuggestions, 500);
        this.state = {
            searchTerm: props.searchTerm,
            searchSuggestions: {
                searches: [],
                shops: []
            }
        };
    }

    render() {
        const {
            searchTerm,
            isSearchInputFocused,
            suggestedSearches,
            suggestedShops,
            filteredPreviousSearches,
            selectedIndex,
            setSearchSuggestionsElement,
            selectedCategoryId
        } = this.props;

        const changeSearchTerm = () => {
            // console.log(e);
        };

        const suggestionTypes = {
            PREVIOUS_SEARCH: 'PREVIOUS_SEARCH',
            SUGGESTED_SEARCH: 'SUGGESTED_SEARCH',
            SUGGESTED_SHOP: 'SUGGESTED_SHOP',
            ADVANCED_OPTIONS: 'ADVANCED_OPTIONS'
        };

        const getComponent = (item, index) => {
            const isSelected = index === selectedIndex;
            const components = {
                [suggestionTypes.PREVIOUS_SEARCH]: (
                    <PreviousSearchesListItem
                        {...item.jsxProps}
                        isSelected={isSelected}
                        selectedCategoryId={selectedCategoryId}
                    />
                ),

                [suggestionTypes.SUGGESTED_SEARCH]: (
                    <SearchesSuggestionsListItem
                        {...item.jsxProps}
                        isSelected={isSelected}
                        selectedCategoryId={selectedCategoryId}
                    />
                ),

                [suggestionTypes.SUGGESTED_SHOP]: (
                    <ShopsSuggestionsListItem
                        {...item.jsxProps}
                        isSelected={isSelected}
                    />
                ),

                [suggestionTypes.ADVANCED_OPTIONS]: (
                    <Fragment key={suggestionTypes.ADVANCED_OPTIONS}>
                        <AdvancedSearchListItem
                            key={'advanced-search'}
                            isSelected={isSelected}
                        />
                        <SellerSearchListItem
                            key={'seller-search'}
                            isSelected={index + 1 === selectedIndex} // Requires this item to be the last in the list-group..
                        />
                    </Fragment>
                )
            };

            if (components[item.type]) {
                return components[item.type];
            }
        };

        const allSuggestions = []
            .concat(
                (filteredPreviousSearches || []).map((i, key) => ({
                    type: suggestionTypes.PREVIOUS_SEARCH,
                    key: key,
                    jsxProps: {
                        item: i,
                        key: key,
                        searchTerm: searchTerm,
                        changeSearchTerm: changeSearchTerm
                    }
                }))
            )
            .concat(
                (suggestedSearches || []).map((i, key) => ({
                    type: suggestionTypes.SUGGESTED_SEARCH,
                    text: i.text,
                    categories: i.categories,
                    jsxProps: {
                        item: i,
                        key: `${suggestionTypes.SUGGESTED_SEARCH}-${key}`,
                        searchTerm: searchTerm,
                        changeSearchTerm: changeSearchTerm
                    }
                }))
            )
            .concat(
                (suggestedShops || []).map((i, key) => ({
                    type: suggestionTypes.SUGGESTED_SHOP,
                    memberId: i.memberId,
                    name: i.name,
                    urlName: i.urlName,
                    jsxProps: {
                        item: i,
                        key: `${suggestionTypes.SUGGESTED_SHOP}-${key}`,
                        searchTerm: searchTerm,
                        changeSearchTerm: changeSearchTerm
                    }
                }))
            );

        allSuggestions.push({
            type: suggestionTypes.ADVANCED_OPTIONS
        });

        const suggestions2show = allSuggestions.map((i, index) =>
            getComponent(i, index)
        );

        return (
            <section
                className={`slim-header__search-suggestions rounded ${
                    isSearchInputFocused ? 'visible' : ''
                }`}
                ref={setSearchSuggestionsElement}>
                {isSearchInputFocused ? (
                    <div className="list-group">{suggestions2show}</div>
                ) : null}
            </section>
        );
    }
}

// TODO
SearchSuggestion.propTypes = {
    searchTerm: PropTypes.string,
    previousSearches: PropTypes.array,
    isSearchInputFocused: PropTypes.bool,
    filteredPreviousSearches: PropTypes.array,
    suggestedSearches: PropTypes.array,
    suggestedShops: PropTypes.array,
    selectedIndex: PropTypes.number,
    onChangeSearchTerm: PropTypes.func,
    setSearchSuggestionsElement: PropTypes.func,
    selectedCategoryId: PropTypes.number
};

export default SearchSuggestion;
